import { Vector3 } from '@babylonjs/core';
import { CameraConfiguration } from '../interfaces/CameraConfiguration';

export default {
	target: Vector3.Zero(),
	alpha: 135 * (Math.PI / 180),
	beta: 1.15,
	radius: 50,
	useFramingBehavior: true,
	framingTime: 300,
	elevationReturnTime: 300,
} as CameraConfiguration;
